import { ThemeProvider as NextThemesProvider } from "next-themes";
import { ReactNode } from "react";

/**
 * Fournisseur de thème TAMA (clair / sombre / système).
 * `attribute="class"` applique la classe `.dark` sur <html>, ce qui active
 * les tokens sémantiques sombres définis dans `src/index.css`.
 * Les transitions CSS restent actives pour un fondu doux entre apparences.
 */
export const ThemeProvider = ({ children }: { children: ReactNode }) => (
  <NextThemesProvider
    attribute="class"
    defaultTheme="system"
    enableSystem
    storageKey="tama-theme"
  >
    {children}
  </NextThemesProvider>
);
